<template>
    <div class="row">
        <div class="documentation">
            <nav aria-label="breadcrumb" class="d-none d-xl-block">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#">Документы</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Список документов</li>
                </ol>
            </nav>
            <div class="title-block">
                <div class="title-block__left">
                    <div class="title-block__title">
                        Список документов
                    </div>
                    <a class="title-block__btn btn-add btn-primary btn" href="#">
                        Добавить
                    </a>
                </div>
            </div>
            <div class="row g-2 mb-4">
                <div class="col-8">
                    <div class="search-control doc-search-control">
                        <input type="text" class="search-control__input form-control" placeholder="Поиск"
                            @click="openSuggestions" @focus="openSuggestions" @input="resetChoice" :value="parentDoc">
                        <button class="search-control__input-btn reset-btn">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"
                                    fill="currentColor"></path>
                            </svg>
                        </button>
                        <ul class="search-suggestions doc-suggestions" :class="{ open: suggestionsOpen }" @click.prevent="docSuggesttionsHandler" >
                            <li>
                                <div class="doc-suggestions__item doc-suggestions__item_light">
                                    <a href="#">
                                        <span>DS&nbsp;&laquo;Электронная очередь&raquo;</span>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="doc-suggestions__item doc-suggestions__item_light">
                                    <a href="#">
                                        <span>DS&nbsp;&laquo;Информационный киоск&raquo;</span>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="doc-suggestions__item doc-suggestions__item_light">
                                    <a href="#">
                                        <span>DS&nbsp;&laquo;Информационный дисплей&raquo;</span>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-4 d-flex justify-content-start">
                    <v-select class="ftoggle" v-model="client" :options="['Клиент', 'Неофарм', 'Клиент 2', 'Клиент 3']"
                        :deselectFromDropdown="false" :clearable="false" :searchable="false">
                    </v-select>
                </div>
            </div>
            <div class="doc-table-responsive table-responsive">
                <table class="doc-table  table">
                    <thead>
                        <tr>
                            <th>

                            </th>
                            <th>
                                <div class="th-inner ">
                                    Название документа
                                </div>
                            </th>
                            <th>
                                Создан/Изменен
                            </th>
                            <th>

                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list open">
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__icon vol"></span>
                                    <span class="table-item__title">
                                        DS&nbsp;&laquo;Электронная очередь&raquo;
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <a title="Закрыто для редактирования"
                                        class="table-row-control content-control lock"></a>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 30px">
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Версия 1.0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 30px">
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Версия 2.0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 60px">
                                    <span class="table-item__icon doc"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Версия 2.0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Версия 2.0.1
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Версия 2.0.2
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Версия 2.0.3
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 30px">
                                    <span class="table-item__icon list"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Релизы
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 60px">
                                    <span class="table-item__icon doc"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Релиз 1.0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Релиз 1.0.1
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Релиз 1.0.2
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Релиз 1.0.3
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 60px">
                                    <span class="table-item__icon doc"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Релиз 2.0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 60px">
                                    <span class="table-item__icon doc"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Релиз 3.0
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 30px">
                                    <span class="table-item__icon list"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Инструкции
                                    </span>
                                    <button class="table-item__add-section reset-btn">
                                        Добавить раздел
                                    </button>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 60px">
                                    <span class="table-item__icon doc"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Краткое описание программы
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Инфокиоск
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 60px">
                                    <span class="table-item__icon doc"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Табло электронной очереди Табло электронной очереди Табло электронной очереди
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Табло 1
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Табло 2
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Табло 3
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item has-list open" style="margin-left: 60px">
                                    <span class="table-item__icon doc"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Панель управления
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Пульт оператора 1
                                    </span>
                                    <button class="table-item__add-section reset-btn">Добавить раздел</button>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state active"></div>
                            </td>
                            <td>
                                <div class="table-item" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Пульт оператора 2
                                    </span>
                                    <button class="table-item__add-section reset-btn">Добавить раздел</button>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="doc-table-state"></div>
                            </td>
                            <td>
                                <div class="table-item" style="margin-left: 75px">
                                    <span class="table-item__icon doc small"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Пульт оператора 3
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control history reset-btn"
                                        title="История"></button>
                                    <button class="table-row-control content-control link reset-btn"
                                        title="Получить ссылку"></button>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 30px">
                                    <span class="table-item__icon list"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Системные требования
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list" style="margin-left: 30px">
                                    <span class="table-item__icon list"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        Частые вопросы
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list">
                                    <span class="table-item__icon vol"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        DS&nbsp;&laquo;Информационный киоск&raquo;
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <a title="Закрыто для редактирования"
                                        class="table-row-control content-control lock"></a>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <td>
                                <div class="table-item has-list">
                                    <span class="table-item__icon vol"></span>
                                    <button class="table-item__toggle reset-btn"></button>
                                    <span class="table-item__title">
                                        DS&nbsp;&laquo;Информационный дисплей&raquo;
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div class="doc-table-times">
                                    <div class="doc-table-times__row created">
                                        22.02.2023
                                    </div>
                                    <div class="doc-table-times__row edited">
                                        22.02.2023
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-end align-items-center">
                                    <a title="Закрыто для редактирования"
                                        class="table-row-control content-control lock"></a>
                                    <button class="table-row-control content-control edit reset-btn"
                                        title="Редакьтировать"></button>
                                    <button title="Удалить"
                                        class="table-row-control content-control delete reset-btn"></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DocumentationList",
    data: () => {
        return {
            client: 'Клиент',
            suggestionsOpen: false,
            parentDoc: '',
            content: ''
        };
    },
    methods: {
        docSuggesttionsHandler: function (e) {
            const target = e.target;
            const link = target.closest('a') || false;
            if (link) {
                const text = link.textContent;
                if (text) {
                    this.parentDoc = text;
                }
                this.closeSuggestions();
            }
        },
        resetChoice: function (e) {
            this.parentDocIcon = '';
            e.target.parentElement.setAttribute('class', 'search-control doc-search-control');
            this.openSuggestions();
        },
        openSuggestions: function () {
            this.suggestionsOpen = true;
        },
        closeSuggestions: function () {
            this.suggestionsOpen = false;
        },
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if (e.key == 'Escape') {
                this.closeSuggestions();
            }
        });
        document.addEventListener("click", (e) => {
            if (!e.target.closest('.doc-search-control')) {
                this.closeSuggestions();
            }
        });
    },
};
</script>
